import {
  Carousel,
  CarouselNext,
  CarouselItem,
  CarouselContent,
  CarouselPrevious,
} from '@design-system/Carousel';
import { Skeleton } from '@design-system/Skeleton';
import { cn } from '@/utils/styles';
  
export const NutritionTipSkeleton = () => {
  return (
    <div>
      <Skeleton className="h-8 w-32 m-3" />
      <Skeleton className="h-12 max-w-xl m-3" />
      <Carousel className={cn('w-full relative')}>
        <CarouselContent>
          {Array.from({ length: 10 }).map((_, index) => (
             <CarouselItem key={index} className="max-w-80 min-h-64">
             <div className="pl-2 w-full h-full">
               <Skeleton className="size-full" />
             </div>
           </CarouselItem>
          ))}
        </CarouselContent>

        <CarouselPrevious variant="ghost" />
        <CarouselNext variant="ghost" />
      </Carousel>
    </div>
  );
};